import { SmdBalance, SmdBalanceDef, SMD_IMBALANCE_THRESHOLD } from "../type/batch-def";

export class SmdBalanceAdapter {
  /**
   * SMD の応答を画面用に正規化する。
   *
   * 偏りの判定は符号を問わないので絶対値で見る。偏りの大きい順に並べて、
   * 確認すべき共変量が表の先頭に来るようにする。
   */
  static toOutputDTO(data: SmdBalanceDef): SmdBalance {
    const rows = (data?.rows ?? []).map((row) => ({
      id: row.parent_node_id,
      name: row.parent_node_name || row.parent_node_id,
      layerNo: row.layer_no,
      smd: row.smd,
      imbalanced: Math.abs(row.smd) > SMD_IMBALANCE_THRESHOLD,
    }));

    rows.sort((a, b) => Math.abs(b.smd) - Math.abs(a.smd));

    return {
      existingRowCount: data?.existing_row_count ?? 0,
      uploadedRowCount: data?.uploaded_row_count ?? 0,
      weighted: data?.weighted ?? false,
      rows,
    };
  }
}
